import React from "react";

const GalleryIcon = () => (
  <svg width="20" height="20" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="20" height="18" rx="5" stroke="#8B4FD9" strokeWidth="1.8" />
    <circle cx="9.5" cy="10" r="1.8" fill="#C9B3E8" />
    <path d="M4 18.5L10 12.5L14.5 17L18 13.5L22 17.5" stroke="#C9B3E8" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8H14M14 8L9 3M14 8L9 13" stroke="#8B4FD9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* Exact wave background from the provided Rectangle (Gallery) — wrapped so CSS handles the
   rounded top corners cleanly (the SVG's own corner curve gets distorted when stretched) */
const CardBackground = () => (
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "56px",
      overflow: "hidden",
      borderTopLeftRadius: "20px",
      borderTopRightRadius: "20px",
      zIndex: 0,
    }}
  >
    <svg
      viewBox="0 0 343 62"
      preserveAspectRatio="none"
      style={{ display: "block", width: "100%", height: "100%" }}
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0H323C334.046 0 343 8.9543 343 20V36.279C295.5 54.3297 253.531 13.6906 188 32.7692C64 68.8705 0 61.3494 0 61.3494V20Z"
        fill="#E7F3D0"
      />
    </svg>
  </div>
);

const styles = {
  outer: {
    position: "relative",
    width: "100%",
    maxWidth: "400px",
    borderRadius: "20px",
    overflow: "hidden",
    background: "#CFE3B0",
    boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
    fontFamily: "inherit",
    padding: "0 0 12px 0",
    height: "155px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  header: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px 4px 16px",
  },
  headerLeft: { display: "flex", alignItems: "center", gap: "8px" },
  iconWrap: {
    width: "26px",
    height: "26px",
    borderRadius: "7px",
    border: "1.5px solid #8B4FD9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.25)",
    flexShrink: 0,
  },
  title: { fontSize: "18px", fontWeight: 700, color: "#1E1E1E", margin: 0 },
  badge: {
    background: "#151515",
    color: "#FF3D9A",
    fontSize: "12px",
    fontWeight: 700,
    borderRadius: "8px",
    padding: "4px 12px",
    minWidth: "26px",
    textAlign: "center",
  },
  body: {
    position: "relative",
    zIndex: 2,
    padding: "4px 16px 0 16px",
  },
  bodyText: {
    fontSize: "12.5px",
    fontWeight: 500,
    color: "#1E1E1E",
    lineHeight: 1.4,
    margin: 0,
  },
  viewAll: {
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13.5px",
    fontWeight: 700,
    color: "#8B4FD9",
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: 0,
  },
};

const GalleryAdvertisement = ({
  title = "Gallery",
  count = "09",
  message = "Promote your offers and videos on here",
  onViewAll,
}) => {
  return (
    <div style={styles.outer}>
      <CardBackground />

      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <div style={styles.iconWrap}>
            <GalleryIcon />
          </div>
          <p style={styles.title}>{title}</p>
        </div>
        <span style={styles.badge}>{count}</span>
      </div>

      <div style={styles.body}>
        <p style={styles.bodyText}>{message}</p>
        <button style={styles.viewAll} onClick={onViewAll}>
          View all <ArrowIcon />
        </button>
      </div>
    </div>
  );
};

export default GalleryAdvertisement;